import { render, staticRenderFns } from "./ed-error.vue?vue&type=template&id=2038e1c8&"
import script from "./ed-error.ts?vue&type=script&lang=ts&"
export * from "./ed-error.ts?vue&type=script&lang=ts&"
import style0 from "./ed-error.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports